import { CardValue } from '@bg-shared/enums/CardValue';
import { CARD_SHORT_VALUE_10 } from '@bg-shared/constants/constants';

export const formatCardValue = (value: string): CardValue =>
    value.toLowerCase().replace(CARD_SHORT_VALUE_10, CardValue.TEN) as CardValue;
